import "core-js/modules/es.array.push.js";
import { dayjs } from 'element-plus';
export const imgSize = async file => {
  const fileData = file;
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = function (e) {
      const data = e.target?.result;
      const image = new Image();
      image.onload = function () {
        const width = image.width;
        const height = image.height;
        resolve({
          width,
          height
        });
      };
      image.src = data;
    };
    reader.readAsDataURL(fileData);
  });
};
export const verifyPwd = pwd => {
  let err = '';
  if (pwd.length < 7) {
    err = '密码不能少于7位';
  }
  if (!/[a-z]+/.test(pwd)) {
    err = '密码必需包括小写英文字母';
  }
  if (!/[A-Z]+/.test(pwd)) {
    err = '密码必需包括大写英文字母';
  }
  if (!/\d+/.test(pwd)) {
    err = '密码必需包括数字';
  }
  return err;
};
export const toJSON = jsonStr => {
  let ret;
  try {
    ret = JSON.parse(jsonStr);
  } catch (error) {
    ret = new Function(`${jsonStr}`)();
  }
  return ret;
};
/**
 * 转换json字符串为 json对象
 * @param jsonStr
 * @param defaultValue
 * @param attempt
 */
export const parseJson = (jsonStr, defaultValue, attempt = false) => {
  let ret;
  try {
    if (!attempt) {
      ret = JSON.parse(jsonStr);
    } else {
      ret = new Function(`return (${jsonStr});`)();
    }
  } catch (e) {
    if (!attempt) {
      ret = parseJson(jsonStr, defaultValue, true);
    } else {
      ret = defaultValue || null;
    }
  }
  return ret;
};
export const getIntId = () => {
  const timeStr = Date.now().toString();
  const part5 = timeStr.slice(timeStr.length - 5);
  const randam = Math.floor(Math.random() * 20) + 1;
  return Number(`${part5}${randam}`);
};
export const encodeRichText = str => {
  return str.replaceAll(' ', '&nbsp;').replaceAll('\n', '<br />');
};
export const decodeRichText = (str = '') => {
  return str.replaceAll('&nbsp;', ' ').replaceAll('<br />', '\n');
};
export const is = (str, type) => {
  return Object.prototype.toString.call(str) === `[object ${type}]`;
};
export const canvas2File = (canvas, type = 'image/png', name = 'image.png') => {
  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => {
      if (blob) {
        const file = new File([blob], name, {
          type
        });
        resolve(file);
      }
      reject(null);
    }, type);
  });
};
export const downloadUrl = (url, name) => {
  const a = document.createElement('a');
  a.download = name;
  a.href = url;
  a.style.position = 'fixed';
  a.style.top = '-9999px';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
export const logger = (title, msg, level = 'log') => {
  console.log(`${level}.[aos-admin]: ${title} ==> ${msg}, ${dayjs().format('YYYY-MM-DD HH:mm:ss')}`);
};
export const validateForm = async form => {
  try {
    await form?.value?.validate();
    return true;
  } catch (error) {
    return false;
  }
};
/**
 * 在模板数据中找到所有指定kind的节点
 * @param tree
 * @param kind
 */
export const findNodeInTree = (tree, kind) => {
  let ret = [];
  for (let i = 0, len = tree.length || 0; i < len; i++) {
    const node = tree?.[i];
    if (node) {
      if (node.kind === kind) {
        ret.push(node);
      } else if (node.children && node.children.length) {
        ret = [...ret, ...findNodeInTree(node.children, kind)];
      }
    }
  }
  return ret;
};
/**
 * 把模板tree平铺为列表
 * @param list
 * @param filter
 */
export const flatTempTree = (list, filter) => {
  const ret = [];
  list.forEach(d => {
    const item = {
      ...d
    };
    delete item.children;
    if (filter) {
      filter(item) && ret.push(item);
    } else {
      ret.push(item);
    }
    if (d.children && d.children.length) {
      const rr = flatTempTree(d.children, filter);
      ret.push(...rr);
    }
  });
  return ret;
};
const findAllTextNode = (list, exclude) => {
  const ret = [];
  for (const item of list) {
    // 不是正常节点, 或被隐藏的节点
    const invalidNode = item.nodeType !== Node.ELEMENT_NODE || window.getComputedStyle(item).display === 'none' || window.getComputedStyle(item).visibility === 'hidden';
    if (item.firstChild?.nodeName.toLowerCase() === '#text' && (item.firstChild?.nodeValue?.length || 0) > 0 && !invalidNode && (exclude ? !exclude(item) : true)) {
      ret.push(item);
    }
    if (item.children && item.children.length) {
      ret.push(...findAllTextNode(item.children));
    }
  }
  return ret;
};
/**
 * 找到最后一个展示内容的元素
 * @param ele
 * @param exclude
 */
export const findLastDisplayNode = (ele, exclude) => {
  let bottommostElement = null;
  let maxBottom = -Infinity;
  const nodes = findAllTextNode(ele.children, exclude);
  // 递归遍历 DOM 树
  function walk(node) {
    // 检查元素是否有实际渲染内容（排除空元素）
    const rect = node.getBoundingClientRect();
    if (rect.width > 0 && rect.height > 0) {
      if (rect.bottom >= maxBottom) {
        maxBottom = rect.bottom;
        bottommostElement = node;
      }
    }
  }
  for (const node of nodes) {
    walk(node);
  }
  return bottommostElement;
};
/**
 * 计算指定元素最后一行, 与容器之间还有多少空间
 */
export const lastLinkSpace = (element, container) => {
  const range = document.createRange();
  const textNode = element.lastChild; // 假设 div 内只有文本（无嵌套元素）
  if (!textNode) return 0;
  const textLength = textNode.nodeValue?.length || 0;
  range.setStart(textNode, textLength - 1);
  range.setEnd(textNode, textLength);
  // const selection = window.getSelection();
  // selection?.removeAllRanges();
  // selection?.addRange(range);
  // const rect = range.getBoundingClientRect();
  // const div = document.createElement('div');
  // div.style.position = 'absolute';
  // div.style.top = `${rect.top}px`;
  // div.style.left = `${rect.left}px`;
  // div.style.width = `${rect.width}px`;
  // div.style.height = `${rect.height}px`;
  // div.style.border = '1px solid red';
  // div.style.zIndex = '999999';
  // document.body.appendChild(div);
  // 容器的右坐标
  const containerRect = container.getBoundingClientRect();
  // 选区的右坐标
  const rangeRect = range.getBoundingClientRect();
  return containerRect.right - rangeRect.right;
};
export const convertStringArrToNumberArr = arr => {
  return arr.map(item => Number(item));
};
/**
 * 把map对象变成像stringify那样的json字符串
 * 不支持k/v中v是Map的情况
 * @param map
 */
export const mapStringify = map => {
  const arr = [];
  map.forEach((value, key) => {
    arr.push(`"${key}": ${JSON.stringify(value)}`);
  });
  return `{${arr.join(',')}}`;
};
export const mapParse = str => {
  const reg = /"[\d^"]+"(?=:)/g;
  const map = new Map();
  const hash = str.match(reg);
  const obj = toJSON(str);
  if (hash && hash.length) {
    const ids = hash.map(idStr => idStr.replaceAll('"', ''));
    map.set('show', obj.show);
    ids.forEach(id => {
      map.set(id, obj[id]);
    });
  } else {
    for (const key in obj) {
      map.set(key, obj[key]);
    }
  }
  return map;
};